export default __webpack_public_path__ + "7e5b1277578532407ff4b8e957954e24.svg";